import { Button } from '@/shared/ui';
import styles from './BottomNav.module.css';

interface BottomNavProps {
  currentStep: number;
  totalSteps: number;
  onBack: () => void;
  onNext: () => void;
  nextDisabled?: boolean;
}

export function BottomNav({
  currentStep,
  totalSteps,
  onBack,
  onNext,
  nextDisabled,
}: BottomNavProps) {
  if (currentStep <= 0) return null;

  return (
    <div className={styles.bottomNav}>
      <Button size="sm" onClick={onBack}>
        ← Back
      </Button>
      <span className={styles.stepCount}>
        Step {currentStep} of {totalSteps}
      </span>
      {currentStep < totalSteps ? (
        <Button size="sm" variant="primary" onClick={onNext} disabled={nextDisabled}>
          Next →
        </Button>
      ) : (
        <span />
      )}
    </div>
  );
}
